import React from "react"

import styled from "@emotion/styled"
import { Typography } from "@mui/material"

import { PRODUCTION_STEPS_COL_WIDTHS } from "../../../../utils/constant"
import { COLORS, roundNumber } from "../../../../utils"
import { StyledSectionFirstBodyColumn, StyledStepBodyCell } from "../StyledSectionComponents"
import { convertKilosIntoGrams } from "../../../../utils/ressources"
import { displaySectionName, getSectionNameStyles } from "../../../../utils/sectionUtils"

const widths = PRODUCTION_STEPS_COL_WIDTHS
export const COMPONENT_NAME = "SECTIONS"
const StyledText = styled(Typography, {
  shouldForwardProp: (prop) => prop !== "packagingDisplay"
})(({ packagingDisplay = true }) => {

  return {
    fontWeight: 600,
    fontSize: 14,
    color: packagingDisplay ? COLORS.BLACK_700 : COLORS.BLACK_500
  }
})

const SectionPreview = ({ section }) => {
  return (
    <>
      <StyledSectionFirstBodyColumn className="flexRow center" packagingDisplay={section.packagingDisplay}>
        <StyledText 
          packagingDisplay={section.packagingDisplay} 
          sx={getSectionNameStyles(section)}
        >
          {displaySectionName(section)}
        </StyledText>
      </StyledSectionFirstBodyColumn>
      <StyledStepBodyCell align="left" width={widths[1]}>
        <StyledText packagingDisplay={section.packagingDisplay}>{roundNumber(convertKilosIntoGrams(section.grossWeight), 3) || "-"}</StyledText>
      </StyledStepBodyCell>
      <StyledStepBodyCell align="left" width={widths[2]}>
        <StyledText packagingDisplay={section.packagingDisplay}>-</StyledText>
      </StyledStepBodyCell>
      <StyledStepBodyCell align="left" width={widths[3]}>
        <StyledText packagingDisplay={section.packagingDisplay}>
          {section.cost ? `${roundNumber(section.cost, 3)} €` : "_"}
        </StyledText>
      </StyledStepBodyCell>
      <StyledStepBodyCell align="left" width={widths[4]}>
        <StyledText packagingDisplay={section.packagingDisplay}>-</StyledText>
      </StyledStepBodyCell>
      <StyledStepBodyCell align="left" width={widths[5]}>
        <StyledText packagingDisplay={section.packagingDisplay}>-</StyledText>
      </StyledStepBodyCell>
      <StyledStepBodyCell align="left" width={widths[6]}>
        <StyledText packagingDisplay={section.packagingDisplay}>{roundNumber(convertKilosIntoGrams(section.netWeight), 3) || "-"}</StyledText>
      </StyledStepBodyCell>
      <StyledStepBodyCell align="left" width={widths[7]}>
        <StyledText packagingDisplay={section.packagingDisplay}>-</StyledText>
      </StyledStepBodyCell>
      <StyledStepBodyCell align="left" width={widths[8]}>
        <StyledText packagingDisplay={section.packagingDisplay}>-</StyledText>
      </StyledStepBodyCell>
      <StyledStepBodyCell align="left" width={widths[9]}>
        <StyledText packagingDisplay={section.packagingDisplay}>-</StyledText>
      </StyledStepBodyCell>
      <StyledStepBodyCell align="left" width={widths[10]}>
        <StyledText packagingDisplay={section.packagingDisplay}>-</StyledText>
      </StyledStepBodyCell>
      <StyledStepBodyCell align="left" width={widths[11]}>
        <StyledText packagingDisplay={section.packagingDisplay}>-</StyledText>
      </StyledStepBodyCell>
      <StyledStepBodyCell align="left" width={widths[12]}>
        <StyledText packagingDisplay={section.packagingDisplay}>-</StyledText>
      </StyledStepBodyCell>
      <StyledStepBodyCell align="left" width={widths[13]}>
        <StyledText packagingDisplay={section.packagingDisplay}>-</StyledText>
      </StyledStepBodyCell>
      <StyledStepBodyCell packagingDisplay={section.packagingDisplay} align="left" width={widths[14]} />
    </>
  )
}

export default SectionPreview
